import type { SVGProps } from 'react';
const checkbox = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd" id="Flight-Rooms" stroke="none" strokeWidth={1}>
      <g
        fill={props.color ?? '#FFFFFF'}
        id="AvioBookConnect/Web/Flightrooms/FlightroomDetail-requests2b"
        stroke={props.color ?? '#A1B5C0'}
        transform="translate(-425, -341)"
      >
        <g id="modal" transform="translate(405, 200)">
          <g id="user-copy" transform="translate(0, 131)">
            <g id="AviobookBase/Components2.0/Checkboxes/checkbox-filled-default" transform="translate(20, 10)">
              <rect fill={props.color ?? '#FFF'} height={22} id="Rectangle" rx={4} width={22} x={0.5} y={0.5} />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default checkbox;
